export default __webpack_public_path__ + "static/media/noAssignment.e15ab03b.svg";